import TodoItem from './TodoItem';
import { memo } from 'react';

function TodoList({ taches, changerEtat, supprimerTache }) {
  if (taches.length === 0) {
    return <p>Aucune tâche pour le moment. Ajoutez-en une !</p>;
  }

  return (
    <ul>
      {taches.map((tache) => (
        <TodoItem
          key={tache.id}
          tache={tache}
          changerEtat={changerEtat}
          supprimerTache={supprimerTache}
        />
      ))}
    </ul>
  );
}

export default memo(TodoList);